/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { Epic } from 'redux-observable';
import PortalWebsiteService from 'src/js/api/services/PortalWebsiteService';
import { showMessage } from 'src/js/redux/actions/index';
import { DELETE_PORTAL_WEBSITE, getPortalWebsites, } from 'src/js/redux/actions/PortalWebsite';
import { Create, Request } from '../EpicUtils';

const request: Request<any, number> = {
  type: DELETE_PORTAL_WEBSITE,
  getData: (id) => PortalWebsiteService.deletePortalWebsite(id),
  processData: () => {
    return [
      showMessage({ message: 'Portal instance removed', success: true }),
      getPortalWebsites(true)
    ]
  }
};

export const EpicDeletePortalWebsites: Epic<any, any> = Create(request);
